@if (console.enabled)
{
    <button class="console-launcher" type="button" (click)="isOpen = true"
            aria-label="Open developer console" aria-haspopup="dialog" [attr.aria-expanded]="isOpen">
        Console
    </button>

    @if (isOpen)
    {
        <div class="console-backdrop" (click)="close()">
            <section class="console-panel" role="dialog" aria-modal="true" aria-labelledby="developer-console-title"
                     cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (click)="$event.stopPropagation()"
                     (keydown.escape)="close(); $event.stopPropagation()">
                <header>
                    <h2 id="developer-console-title">Developer console</h2>
                    <button type="button" (click)="console.clear()">Clear</button>
                    <button type="button" (click)="close()" cdkFocusInitial aria-label="Close developer console">Close</button>
                </header>
                <p class="console-description">Live logs · last 500 entries · current page session</p>
                <div class="console-entries" tabindex="0" aria-label="Console logs">
                    @for (entry of console.entries(); track entry.id)
                    {
                        <article class="console-entry" [class.console-warning]="entry.level === 'warn'"
                                 [class.console-error]="entry.level === 'error'">
                            <div class="console-meta">{{ entry.time }} · {{ entry.level }}</div>
                            <pre>{{ entry.message }}</pre>
                        </article>
                    }
                    @empty
                    {
                        <p class="console-empty">No logs captured yet.</p>
                    }
                </div>
            </section>
        </div>
    }
}
